// extracted by mini-css-extract-plugin
export var input = "InputText-module--input--jq3HQ";